
export default {
  name: "PublicRowList",
  props: {
    itemPerRow: [Number, String],
  },
};
